import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {ActivatedRoute, Router} from '@angular/router';
import * as moment from 'moment';
import {faEye} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-event-dyn-list-table',
  templateUrl: './event-dyn-list-table.component.html',
  styleUrls: ['./event-dyn-list-table.component.scss']
})
export class EventDynListTableComponent implements OnInit, OnChanges {

  @Input() filters: any;
  @Input() measures: any[];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  faEye = faEye;
  table: any[] = [];
  eventsDynTable: MatTableDataSource<any>;
  displayedColumns: string[] = [
    'View',
    'Start',
    'End',
    'Duration',
    'ValStart',
    'ValEnd',
    'Gap',
    'ValMin',
    'ValMax',
    'Range',
    'Mean',
    'Median'
  ];
  private projectId: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.projectId = this.route.snapshot.paramMap.get('idProject');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filters) {
      this.initMatTable(this.measures);
    }
  }

  public onViewClick(eventDyn) {
    const isGapNeeded = eventDyn.Duration < 5;
    // const startDateGap = isGapNeeded ?  moment(eventDyn.Start*1000).subtract(30, 'seconds').unix()  : eventDyn.Start;
    // const endDateGap = isGapNeeded ? moment(eventDyn.End*1000).add(30, 'seconds').unix() : eventDyn.End;
    const url = location.origin + '/chart' + '/' + this.projectId + '/' + this.filters.selectedLocation + '/' +
      this.timestampToIsoDateString(eventDyn.Start) + '/' + this.timestampToIsoDateString(eventDyn.End) + '/' + 'dyn-data';
    window.open(url, '_blank');
  }

  public timestampToIsoDateString(timestamp: number, forView: boolean = false) {
    let isoString = moment(timestamp * 1000).toISOString();
    if (forView) {
      isoString = isoString.replace('T', ' ').slice(0, isoString.indexOf('.'));
    }
    return isoString;
  }

  private initMatTable(tableData) {
    this.setRowsColorByCategoryLimit(tableData);
    this.eventsDynTable = new MatTableDataSource<any>(tableData);
    this.eventsDynTable.paginator = this.paginator;
    this.eventsDynTable.sort = this.sort;
    this.cd.detectChanges();
  }

  private setRowsColorByCategoryLimit(data) {
    const minRange = this.filters.minCategoryLimit;
    const mediumRange = this.filters.mediumCategoryLimit;
    const maxRange = this.filters.maxCategoryLimit;
    for (const key in data) {
      const eventDyn = data[key];
      const categoryValue = eventDyn[this.filters.chartCategory];
      let classRow: 'min' | 'medium' | 'max' = null;
      if (!isNaN(minRange) && categoryValue >= minRange) {
        classRow = 'min';
      }
      if (!isNaN(mediumRange) && categoryValue >= mediumRange) {
        classRow = 'medium';
      }
      if (!isNaN(maxRange) && categoryValue >= maxRange) {
        classRow = 'max';
      }
      eventDyn.rowClassByCategoryLimit = classRow;
    }
  }
    roundedValue(number: number) {
    return (Math.round(number * 1000)) / 1000;
  }
}
